import { User } from '../user/user.model';

/** Une entree de `training.apprentices` : la fiche et ses tuteurs, par identifiant. */
export interface EntreeEffectif {
  id: string;
  tutors?: string[];
}

/**
 * Construit l'effectif d'une formation a partir de la liste qu'elle porte.
 *
 * L'effectif d'une promotion est `training.apprentices` — une liste
 * d'identifiants, ecrite a l'inscription et jamais modifiee par un changement
 * de statut. C'est donc elle qui fait foi, et non le role courant des fiches.
 *
 * L'affichage reconstruisait auparavant la liste depuis les roles :
 * `training.users.apprentices = training.users.alumnis` pour une formation
 * archivee. Une promotion passee se vidait donc de tous ceux qui n'etaient plus
 * `alumni` — 75 personnes invisibles en production le 03/09/2026 sur 316
 * referencees, et une de plus a chaque reinscription.
 *
 * Aucune copie figee n'est necessaire : la donnee est deja immuable. La figer
 * une seconde fois dupliquerait des donnees personnelles qui survivraient a une
 * demande d'effacement, sans rien garantir de plus.
 */
export function construireEffectifFige(
  entrees: EntreeEffectif[] | undefined,
  fiches: User[],
): { [id: string]: User } {
  const parId: { [id: string]: User } = {};
  fiches.forEach((fiche) => {
    if (fiche?.id) {
      parId[fiche.id] = fiche;
    }
  });

  const effectif: { [id: string]: User } = {};
  (entrees || []).forEach((entree) => {
    const fiche = entree && parId[entree.id];
    if (!fiche) {
      // Fiche supprimee depuis : rien a afficher, mais l'effectif enregistre
      // garde sa trace.
      return;
    }
    fiche.tutors = (entree.tutors || []).map((tutorId) => parId[tutorId]).filter(Boolean);
    effectif[entree.id] = fiche;
  });

  return effectif;
}
